import { AirdropVault } from "@components/V2/Vault";
import PageLayout from "@components/PageLayout";

const VaultPage = () => {
  return (
    <PageLayout extraMarginTop={false}>
      <AirdropVault />
    </PageLayout>
  );
};

export default VaultPage;
